import { RootStore } from "./RootStore";
import {
  getScans,
  getScan,
  createScan,
  updateScan,
  getLastScanOnMachine,
  removeScan,
  canBeUpdated,
  getLastScanOnBoard,
} from "../vendor";
import { ScanType } from "../vendor/types";

export class ScanStore {
  protected rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  public getScan = async (id: number) => {
    try {
      return await getScan(id);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a leitura.",
        "error"
      );
      return null;
    }
  };

  public getScans = async (
    where: {
      byUser?: string;
      partnerId?: number;
      scanType: Array<
        "normalScanType" | "adjustmentScanType" | "surveyScanType"
      >;
      machineId?: number;
      gameId?: number;
      period?: {
        dateInit?: string;
        dateEnd?: string;
      };
    },
    limit?: number,
    offset?: number
  ) => {
    try {
      return await getScans(where, limit, offset);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a lista de leituras.",
        "error"
      );
      return null;
    }
  };

  public createScan = async (data: {
    machineId: number;
    scanType: ScanType;
    obs: string;
    meterCurrentEntry: number;
    meterCurrentExit: number;
  }) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      const Scan = await createScan(data);

      this.rootStore.generalStore.setShowLoading(false);

      this.rootStore.generalStore.showSnackbar(
        "Máquina lida com sucesso!",
        "success"
      );

      return Scan;
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível ler essa máquina.",
        "error"
      );
      this.rootStore.generalStore.setShowLoading(false);

      return null;
    }
  };

  public canBeUpdated = async (scanId: number) => {
    let bool = false;
    try {
      this.rootStore.generalStore.setShowLoading(true);

      bool = await canBeUpdated(scanId);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Essa leitura não pode ser editada.",
        "error"
      );
    } finally {
      this.rootStore.generalStore.setShowLoading(false);
    }

    return bool;
  };

  public updateScan = async (
    data: {
      obs?: string;
      meterCurrentEntry?: number;
      meterCurrentExit?: number;
    },
    scanId: number
  ) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      const scan = await updateScan(data, scanId);

      this.rootStore.generalStore.showSnackbar(
        "Leitura editada com sucesso!",
        "success"
      );

      return scan;
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível editar essa leitura.",
        "error"
      );
    } finally {
      this.rootStore.generalStore.setShowLoading(false);
    }
  };

  public removeScan = async (id: number) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      await removeScan(id);
      this.rootStore.generalStore.showSnackbar(
        "Leitura cancelada com sucesso!",
        "success"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return true;
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível cancelar essa leitura.",
        "error"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return false;
    }
  };

  public getLastScanOnMachine = async (machineId: number) => {
    try {
      return await getLastScanOnMachine(machineId);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a leitura.",
        "error"
      );
      return null;
    }
  };

  public getLastScanOnBoard = async (boardId: number) => {
    try {
      return await getLastScanOnBoard(boardId);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a leitura.",
        "error"
      );
      return null;
    }
  };
}
